import React, { useEffect, useState } from "react";
import { Menu, Dropdown, Button, Space } from "antd";
import { MenuOutlined, GlobalOutlined } from "@ant-design/icons";
import "./Navigation.css"; // Add your styles here
import { sanecka } from "../assets/assets";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import FooterComponent from "../footer/Footer";
import FloatingButtons from "../common/FloatingButtons";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../actions/LanguageActions";

const Navigation = ({ isLoggedIn }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { translations, language } = useSelector((state) => state.language);

    // const [currentLanguage, setCurrentLanguage] = useState("English");
    const [selectedKey, setSelectedKey] = useState("");

    // Update selectedKey based on the current route
    useEffect(() => {
        const currentItem = menuItems.find((item) => item.route === location.pathname);
        if (currentItem) {
            setSelectedKey(currentItem.key);
        } else if ("/kipaji" === location.pathname) {
            setSelectedKey('artist');
        } else {
            setSelectedKey("");
        }
    }, [location]);


    const handleLanguageChange = (language) => {
        // dispatch(setLanguage(language === "en" ? "sw" : "en"));
        dispatch(setLanguage(language));
        // setCurrentLanguage(language);
        // Logic to handle language change (e.g., update i18next, context, or app state)
    };

    const languageMenu = (
        <Menu>
            {/* {language === "en" ? "Swahili" : "English"} */}
            <Menu.Item onClick={() => handleLanguageChange("en")}>{translations.navigation.en}</Menu.Item>
            <Menu.Item onClick={() => handleLanguageChange("sw")}>{translations.navigation.sw}</Menu.Item>
        </Menu>
    );


    // Handle menu item click and navigation
    const handleMenuClick = (e) => {
        const clickedItem = menuItems.find((item) => item.key === e.key);
        if (clickedItem) {
            navigate(clickedItem.route);
        }
    };

    const handleMobileMenuClick = (item) => {
        navigate(item.route);
    };


    const menuItems = [
        { label: `${translations.navigation.home}`, key: "home", route: "/" },
        { label: `${translations.navigation.talentSearch}`, key: "artist", route: "/talent" },
    ];

    return (
        <div>
            <div className="navigation">
                <div className="navigation-left">
                    <img
                        src={sanecka}
                        alt="Sanecka Logo"
                        className="navigation-logo"
                    />
                    <Menu
                        mode="horizontal"
                        items={menuItems}
                        disabledOverflow={true}
                        className="navigation-menu"
                        onClick={(e) => handleMenuClick(e)}
                        selectedKeys={[selectedKey]} // Sync selected key with route
                    />
                </div>

                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    <div className="navigation-right">
                        <Space
                            // size="middle"
                            // <Space size={window.innerWidth < 768 ? "small" : "middle"}>

                            style={{ gap: window.innerWidth < 300 ? "0px" : "5px" }}
                        >
                            <Dropdown overlay={languageMenu} placement="bottomRight">
                                <Button icon={<GlobalOutlined />}>
                                    {language === "sw" ? `${translations.navigation.sw}` : `${translations.navigation.en}`}
                                </Button>
                            </Dropdown>
                            {!isLoggedIn && <Button className="login-button-main" type="primary">
                                <Link to="/login" >
                                    {translations.navigation.memberLogin}
                                </Link>
                            </Button>}
                        </Space>
                    </div>

                    <div className="navigation-mobile">
                        <Dropdown
                            overlay={
                                <Menu>
                                    {menuItems.map((item) => (
                                        <Menu.Item key={item.key} onClick={() => handleMobileMenuClick(item)}>{item.label}</Menu.Item>
                                    ))}
                                    <Menu.Divider />
                                    {/* <Menu.Item onClick={() => handleLanguageChange("English")}>
                English
              </Menu.Item>
              <Menu.Item onClick={() => handleLanguageChange("Swahili")}>
              Swahili
              </Menu.Item> */}
                                    {
                                        !isLoggedIn &&
                                        <Menu.Item>
                                            <Link to="/login" >
                                                {translations.navigation.memberLogin}
                                            </Link>
                                        </Menu.Item>
                                    }
                                </Menu>
                            }
                            trigger={["click"]}
                        >
                            <Button icon={<MenuOutlined />} />
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div>
                <Outlet /> {/* Render child routes */}
            </div>
            <FloatingButtons />
            <FooterComponent />

        </div>
    );
};

export default Navigation;
